const initShowPassword = () => {
  const bslVariables = bsl_variables || {};
  const showPasswordButton = document.querySelectorAll( '.password-form__show-password' );

  if (!showPasswordButton.length) {
    return;
  }

  [...showPasswordButton].forEach( button => {
    button.addEventListener( 'click', (event) => {
      event.preventDefault();
      const passwordField = button.previousElementSibling;
      const isPasswordVisible = passwordField.type === 'text';

      passwordField.type = isPasswordVisible ? 'password' : 'text';
      button.setAttribute( 'aria-label', isPasswordVisible ? bslVariables.show_password || '' : bslVariables.hide_password || '' );
      button.setAttribute( 'aria-pressed', isPasswordVisible ? 'false' : 'true' );
    } );
  } );
}

export default initShowPassword;